import { render, staticRenderFns } from "./Ranks.vue?vue&type=template&id=6455c3b7&scoped=true"
import script from "./Ranks.vue?vue&type=script&lang=js"
export * from "./Ranks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455c3b7",
  null
  
)

export default component.exports